export default __webpack_public_path__ + "static/media/icone-error-document.66c89e74.svg";